// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { bindActionCreators } from 'redux';
import PopularContentsHelper from './popular-content-helper';
import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';
import Page from 'src/model/page';


const _ = require('lodash');

// Modules
import { ContentCard } from 'components/SharedComponents/content/content-card';
import { ContentContainer } from 'components/SharedComponents/content/content-container';

// Redux
import * as homePageActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/home-page';

const popularContentsHelper = new PopularContentsHelper();

export class PopularContent extends React.Component {

// ------------------------------------------------------------------ LIFECYCLE METHODS ------------------------------------------------------------------

    constructor(props) {
        super(props);

        const currentCategory = props.currentCategory;
        const shouldGetDisplayingKeys = PopularContentsHelper.isCurrentPopularCategoryInData(currentCategory, props);
        const displayingContentKeys = shouldGetDisplayingKeys ? popularContentsHelper.getDisplayDataKeys(currentCategory, props.popularContents) : [];
        const pageNo = this.props.currentPageNumberMap.get(currentCategory);

        const loadingContent = false;

        popularContentsHelper.popularCategories = props.popularContents;
        this.state = { displayingContentKeys, pageNo, loadingContent };
    }

    componentDidMount() {
        if (this.state.displayingContentKeys) {
            this.props.getContents(this.state.displayingContentKeys);
            this.props.getContentsChannel(this.state.displayingContentKeys);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.currentCategory !== this.props.currentCategory) {
            this.categoryChanged(nextProps.currentCategory);
        }

        if (nextProps.popularContents !== this.props.popularContents) {
            const shouldGetDisplayingKeys = PopularContentsHelper.isCurrentPopularCategoryInData(this.props.currentCategory, nextProps);
            const displayingContentKeys = shouldGetDisplayingKeys ? popularContentsHelper.getDisplayDataKeys(this.props.currentCategory, nextProps.popularContents) : [];

            this.setState({ displayingContentKeys, loadingContent: false });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(prevState.displayingContentKeys, this.state.displayingContentKeys)) {
            this.props.getContents(this.state.displayingContentKeys);
            this.props.getContentsChannel(this.state.displayingContentKeys);
        }
    }
// ------------------------------------------------------------------ HELPER METHODS ------------------------------------------------------------------

    categoryChanged(currentCategory) {
        if (PopularContentsHelper.isCurrentPopularCategoryInData(currentCategory, this.props)) {
            const displayDataKeys = popularContentsHelper.getDisplayDataKeys(currentCategory, this.props.popularContents);

            this.setState({displayingContentKeys: displayDataKeys});
        }
    }

    loadMoreClicked() {
        mixpanelTracker.reportLoadMoreClickedOnHomepage(this.props.currentCategory, this.state.pageNo);
        const pageNumber = this.props.currentPageNumberMap.get(this.props.currentCategory) + 1;
        this.setState({pageNo: pageNumber, loadingContent: true});
        this.props.loadMore('POPULAR', [this.props.currentCategory], pageNumber);
    }

    updateScrollPosition() {
        const scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
        this.props.updateScrollPosition(scrollPosition);
    }

    contentClickHandler(content) {
        this.updateScrollPosition();
        mixpanelTracker.reportRecommendedContentCardClick(Page.WATCH_NOW, this.props.currentCategory, 'MOST_POPULAR', content.encodedData);
    }

    contentHeaderClickHandler(content) {
        this.updateScrollPosition();
        mixpanelTracker.reportRecommendedContentCardClick(Page.CHANNEL, this.props.currentCategory, 'MOST_POPULAR');
    }

    createContentCard(content) {
        let cardThumbnail = null;
        if (content.thumbnail && content.thumbnail.cdnLocation) {
            cardThumbnail = content.thumbnail.cdnLocation;
        } else if (content.defaultThumbnail && content.defaultThumbnail.cdnLocation) {
            cardThumbnail = content.defaultThumbnail.cdnLocation;
        }

        const contentCardProps = {
            channelLogo: (content.channelLogoCdn ? content.channelLogoCdn : content.channelLogo) || null,
            channelTitle: content.channelTitle || null,
            contentDuration: content.duration || null,
            contentThumbnail: cardThumbnail,
            contentOnClickHandler: this.contentClickHandler.bind(this, content),
            contentHeaderOnClickHandler: this.contentHeaderClickHandler.bind(this, content),
            contentCategory: content.category || null,
            contentTitle: content.title || null,
            contentPublishDate: content.createdTime || null,
            numOfViews: content.numberOfViews || null,
            contentKey: content.id || null,
            channelKey: content.channelKey || null
        };
        return <ContentCard {...contentCardProps} />;
    }

    displayContentContainer() {
        let renderCurrentCategory = this.renderCurrentCategory();
        return (
            <ContentContainer
              key="categorizedContent"
              contents={renderCurrentCategory}
              t={this.props.t}
              loadMoreClicked={this.loadMoreClicked.bind(this)}
              showLoadMore={
                  this.props.contentMetaData.size > 0 &&
                  popularContentsHelper.canLoadMore(this.props.currentPageNumberMap.get(this.props.currentCategory), this.props.lastPageNumberMap.get(this.props.currentCategory)) &&
                  renderCurrentCategory.length > 0
              }
              isLoading={this.state.loadingContent}
            />
        );
    }
// ------------------------------------------------------------------ RENDERING METHODS ------------------------------------------------------------------

    renderCurrentCategory() {
        const contentArray = [];

        if (this.props.contentMetaData && (this.props.contentMetaData.size > 0)) {
            (this.state.displayingContentKeys || []).forEach(key => {
                if (this.props.contentMetaData.get(key)) {
                    const content = this.props.contentMetaData.get(key);

                    if (popularContentsHelper.isContentInSameDisplayCategory(this.props.currentCategory, content) && popularContentsHelper.shouldDisplayContent(content)) {
                        contentArray.push(this.createContentCard(content));
                    }
                }
            });
        }
        return popularContentsHelper.trimContentsByScreenSize(contentArray);
    }

    render() {
        return (
            <div>
                {this.displayContentContainer()}
            </div>
        );
    }
}

PopularContent.propTypes = {
    t: PropTypes.func,
    currentCategory: PropTypes.string.isRequired,
    popularContents: PropTypes.object.isRequired,
    getContents: PropTypes.func.isRequired,
    getContentsChannel: PropTypes.func.isRequired,
    loadMore: PropTypes.func.isRequired,
    contentMetaData: PropTypes.object,
    updateScrollPosition: PropTypes.func.isRequired,
    lastPageNumberMap: PropTypes.object,
    currentPageNumberMap: PropTypes.object
};

export default connect(state => ({}), dispatch => bindActionCreators(Object.assign({}, homePageActions), dispatch)
)(translate(['translation'])(PopularContent));



// WEBPACK FOOTER //
// ./src/components/home-page/popular/popular-content.js